export const ORGANIZATION_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "ASD Taekwondo Mattei Roma",
  url: "https://taekwondomattei.com",
  logo: "https://taekwondomattei.com/logo.png",
  email: "taekwondomatteiroma@gmail.com",
  sameAs: [
    "https://www.facebook.com/taekwondomattei/",
    "https://www.instagram.com/taekwondomatteiroma/",
  ],
} as const;

export const WEBSITE_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  url: "https://taekwondomattei.com",
  name: "Taekwondo Mattei Roma",
  inLanguage: "it-IT",
} as const;

export const HOME_LOCAL_BUSINESS_SCHEMA = {
  "@context": "https://schema.org",
  "@type": ["LocalBusiness", "SportsActivityLocation"],
  name: "ASD Taekwondo Mattei Roma",
  image: "https://taekwondomattei.com/og-home.jpg",
  url: "https://taekwondomattei.com",
  telephone: "+39 333 334 6514",
  email: "taekwondomatteiroma@gmail.com",
  priceRange: "€€",
  sport: "Taekwondo",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Via Marino Mazzacurati, 90",
    addressLocality: "Roma",
    postalCode: "00148",
    addressRegion: "RM",
    addressCountry: "IT",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 41.8394,
    longitude: 12.3986,
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "16:00",
      closes: "21:00",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: "Saturday",
      opens: "10:00",
      closes: "13:00",
    },
  ],
  areaServed: ["Portuense", "Monteverde", "Bravetta", "Corviale", "Trullo", "Roma"],
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "5",
    reviewCount: "30",
    bestRating: "5",
    worstRating: "1",
  },
} as const;

export const HOME_FAQ_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "Dove praticare Taekwondo a Roma?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "La palestra Taekwondo Mattei Roma si trova in Via Marino Mazzacurati 90, zona Portuense/Monteverde, a pochi minuti da Bravetta, Corviale, Trullo, Casetta Mattei e Casaletto.",
      },
    },
    {
      "@type": "Question",
      name: "Quanto costa un corso di Taekwondo a Roma?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "A Roma il costo indicativo comprende iscrizione annuale (30–80€), quota mensile (40–70€ per 2 lezioni/settimana), dobok (25–40€) ed esami di cintura (20–40€). La prima lezione è gratuita.",
      },
    },
    {
      "@type": "Question",
      name: "Da quale età si può iniziare Taekwondo?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Al Taekwondo Mattei Roma i corsi partono dai 5 anni per i bambini e proseguono con ragazzi, adulti e percorso agonistico. Non esiste un'età massima per iniziare.",
      },
    },
    {
      "@type": "Question",
      name: "La lezione di prova è davvero gratuita?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Sì. La prima lezione è gratuita e senza impegno, sia per bambini che per adulti. Si prenota direttamente dal sito.",
      },
    },
    {
      "@type": "Question",
      name: "Serve attrezzatura per iniziare?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "No. Per la prova basta un abbigliamento comodo. Il dobok si acquista dopo l'iscrizione; le protezioni solo quando si inizia lo sparring.",
      },
    },
  ],
} as const;
